import { withChildren } from '@builder.io/react';
import { usePhoneCampaign } from '@hc-frontend/core-ui';
import React, { PropsWithChildren } from 'react';

export default function ActiveCampaignWrapper({
  children,
  forceShow,
}: PropsWithChildren & {
  forceShow?: boolean;
}) {
  const phoneCampaign = usePhoneCampaign();

  if (phoneCampaign || forceShow) {
    return <>{children}</>;
  }

  return null;
}

export const ActiveCampaignWrapperWithChildren = withChildren(
  ActiveCampaignWrapper,
);
